<div class="nav-steps" fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="24px" fxLayoutGap.lt-md="8px" [ngClass]="shop">
  <a class="step" [ngClass]="{active: step.id === currentStep.id, 'disabled-step': step.id > currentStep.id }" [routerLink]="step.routerLink" *ngFor="let step of steps">
    <div class="step-content-wrp">
      <div class="step-no" [ngClass]="shop" [ngClass.lt-sm]="'small ' + shop " *ngIf="step.id >= currentStep.id">
        {{step.id}}
      </div>
      <div class="step-no" [ngClass.lt-sm]="'small'" *ngIf="step.id < currentStep.id">
        <img src="assets/images/completed-step-{{shop}}.svg" alt="completed">
      </div>
      <p class="step-lable">
        {{step.label}}
      </p>
    </div>
  </a>
</div>
